import { createEntityListPage } from "./createEntityListPage";
import { useSources, useAddSource, useUpdateSource } from "../../api/lists";

export const SourcesPage = createEntityListPage({
  title: "Sources",
  entityType: "source",
  useList: useSources,
  useAdd: useAddSource,
  useUpdate: useUpdateSource,
});
